import { DEFAULT_SEGMENT } from '#client/build-env';

/**
 * Internal routes
 */
export const AUTH_CALLBACK         = '/d/callback';
export const AUTH_LOGIN            = '/d/login';
export const AUTH_LOGOUT           = '/d/logout';
export const SHOP                  = `${DEFAULT_SEGMENT}`;
export const SHOP_BOI              = `${DEFAULT_SEGMENT}/beneficial-ownership-information`;
export const SHOP_CORA             = `${DEFAULT_SEGMENT}/change-of-registered-agent`;
export const SHOP_CORP_ADDONS      = `${DEFAULT_SEGMENT}/corp-addons`;
export const SHOP_DASHBOARD        = `${DEFAULT_SEGMENT}/dashboard`;
export const SHOP_LLC              = `${DEFAULT_SEGMENT}/llc`;
export const SHOP_LLC_ADDONS       = `${DEFAULT_SEGMENT}/llc-addons`;
export const SHOP_LLC_MB           = `${DEFAULT_SEGMENT}/llc-mb`;
export const SHOP_QUOTE            = `${DEFAULT_SEGMENT}/quote`;
export const SHOP_QUOTE_CONCLUSION = `${DEFAULT_SEGMENT}/quote/conclusion`;
export const SHOP_SCORP_ADDONS     = `${DEFAULT_SEGMENT}/s-corp-addons`;
export const SHOP_SMART_LLC        = `${DEFAULT_SEGMENT}/smart-llc`;

/**
 * External routes
 */
export const COMPLETE_CORA = '/r/complete-cora/start';
export const DASHBOARD = '/dashboard';
export const DASHBOARD_BOI = `${DASHBOARD}/[businessEntityUuid]?m=beneficialOwnershipFiling`;
export const FORMATION_TYPES = '/s/formation-types';
export const LEGACY_CORA = '/r/register-cora/init?companyId=[businessEntityUuid]';
export const UJM_COMPLETE_BOI =
  '/f/go/complete_beneficial_ownership_filing?businessEntityUuid=[businessEntityUuid]';
export const UJM_COMPLETE_FORMATION =
  '/f/go/complete_llc_formation?businessEntityUuid=[businessEntityUuid]';
